import ReviewTable from '../ReviewTable.jsx';

/**
 * Routed Review tab — drawing viewer + mapping/compliance context panel.
 * Phase 1: wraps existing ReviewTable shell; IR overlays wired in later phases.
 */
export default function ReviewPage({
  selectedProject,
  reviewNavState,
  onNavigateToLinkFolders,
  onNavigateToCompliance,
}) {
  return (
    <ReviewTable
      selectedProject={selectedProject}
      reviewNavState={reviewNavState}
      onNavigateToLinkFolders={onNavigateToLinkFolders}
      onNavigateToCompliance={onNavigateToCompliance}
    />
  );
}
